// @flow
import React from 'react'

const Single = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C" strokeLinecap="square">
        <path d="M.5 22.5c0-5.523 4.477-10 10-10h2c5.523 0 10 4.477 10 10" />
        <circle cx="11.5" cy="6.5" r="6" />
      </g>
    </svg>
  )
}

export default Single



// WEBPACK FOOTER //
// ./src/components/Icons/Single.js